import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { ITagsAPIResponse } from '../../shared/interfaces/tags.interface';
import { ConversationDetailsModel } from '../../shared/models/conversation-details.model';
import { ContactDetailsModel } from '../../shared/models/contact-details.model';
import { ILeasingPreferences } from '../../shared/models/leasing-preferences.model';
import { ICampaignDetails } from '../../shared/models/campaign-details.model';
import { IAppointmentDetails } from '../../shared/models/appointment-details.model';

export const TAGS_API_ACTIONS = createActionGroup({
  source: 'Tags API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ITagsAPIResponse }>(),
  },
});

export const CONVERSATION_DETAILS_API_ACTIONS = createActionGroup({
  source: 'Conversation Details API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ConversationDetailsModel }>(),
  },
});

export const LEASING_PREFERENCES_API_ACTIONS = createActionGroup({
  source: 'Leasing Preferences API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ILeasingPreferences }>(),
  },
});

export const CONTACT_DETAILS_API_ACTIONS = createActionGroup({
  source: 'Contact Details API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ContactDetailsModel }>(),
  },
});

export const APPOINTMENT_DETAILS_API_ACTIONS = createActionGroup({
  source: 'Appointment Details API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: IAppointmentDetails }>(),
  },
});

export const CAMPAIGN_DETAILS_API_ACTIONS = createActionGroup({
  source: 'Campaign Details API',
  events: {
    get: emptyProps(),
    error: props<{ error: HttpErrorResponse }>(),
    success: props<{ data: ICampaignDetails }>(),
  },
});
